import { Card, CardContent, Grid } from "@mui/material";
import { FormInput } from "../../../../components/hook-form/form-input.component";
import { usersApiKeyStore } from "../../../../api/users-api-key-store";

const styling = {
    paperStyle: { padding: '20px 0px 0' },
};

interface FastFieldComponent {
    userID: any;
}

export const FastFieldComponent = ({ userID }: FastFieldComponent) => {
    return (
        <Card elevation={0} style={styling.paperStyle}>
            <CardContent className="formContainer">
                <Grid container spacing={2}>
                    <Grid item lg={6} sm={6} xl={6} xs={6}>
                        <FormInput type="number" label="FastField UserID" name="fastFieldUserID" />
                    </Grid>
                    <Grid item lg={6} sm={6} xl={6} xs={6}>
                        <FormInput
                            label="FastField Email"
                            name="fastFieldEmailID"
                            validationQueryRoute={(value: any) => value && usersApiKeyStore.validateFastFieldEmail(userID, value)}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}